import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateUsersBrandsInput,
    DeleteUsersBrandsInput,
    UpdateUsersBrandsInput,
    ModelUsersBrandsFilterInput,
    UsersBrands
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class UsersBrandsService {
    private amplifyClient = generateClient();
    constructor() {}

    async listUsersBrands(
        filter: ModelUsersBrandsFilterInput = null
    ): Promise<UsersBrands[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listUsersBrands,
                    variables: {
                        filter
                    }
                })
            ).data.listUsersBrands.items;
            if (data) return data as UsersBrands[];
        } catch (error) {
            console.error('Error finding UsersBrands:', error);
            return null;
        }
    }

    async getUsersBrandById(id: string): Promise<UsersBrands> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getUsersBrands,
                    variables: { id }
                })
            ).data.getUsersBrands;
            if (data) return data as UsersBrands;
        } catch (error) {
            console.error('Error finding UsersBrands:', error);
            return null;
        }
    }

    async getUsersBrandByClientId(clientId: string): Promise<UsersBrands[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.GetUsersBrandByClientId,
                    variables: { clientId }
                })
            ).data.GetUsersBrandByClientId.items;
            if (data) return data as UsersBrands[];
        } catch (error) {
            console.error('Error finding UsersBrands:', error);
            return null;
        }
    }

    async createUsersBrand(
        input: CreateUsersBrandsInput
    ): Promise<UsersBrands> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createUsersBrands,
                    variables: {
                        input
                    }
                })
            ).data.createUsersBrands;
            if (date) return date as UsersBrands;
        } catch (error) {
            console.error('Error creating UsersBrands:', error);
            return null;
        }
    }

    async createUsersBrands(
        input: CreateUsersBrandsInput
    ): Promise<UsersBrands> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createUsersBrands,
                    variables: {
                        input
                    }
                })
            ).data.createUsersBrands;
            if (date) return date as UsersBrands;
        } catch (error) {
            console.error('Error creating UsersBrands:', error);
            return null;
        }
    }

    async updateUsersBrands(
        input: UpdateUsersBrandsInput
    ): Promise<UsersBrands> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateUsersBrands,
                    variables: {
                        input
                    }
                })
            ).data.updateUsersBrands;
            if (date) return date as UsersBrands;
        } catch (error) {
            console.error('Error updated UsersBrands:', error);
            return null;
        }
    }

    async deleteUsersBrands(
        input: DeleteUsersBrandsInput
    ): Promise<UsersBrands> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteUsersBrands,
                    variables: {
                        input
                    }
                })
            ).data.deleteUsersBrands;
            if (date) return date as UsersBrands;
        } catch (error) {
            console.error('Error deleting UsersBrands:', error);
            return null;
        }
    }
}
